import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Containers/Home';
import Login from './Containers/Auth/Login';
import Register from './Containers/Auth/Register';
import Demo from './Containers/Auth/Demo';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CategoryDetail from './Containers/CategoryDetail';

function App() {
  return (
    <div className="App">
      <ToastContainer />

      <Router>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/login' element={<Login />} />
          <Route exact path='/start-free-trial' element={<Register />} />
          <Route exact path='/book-demo' element={<Demo />} />

          <Route path="/menu/:categoryUrl" element={<CategoryDetail />} />
          <Route path="/product/:subcategoryUrl" element={<CategoryDetail />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
